import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/enum_pattern_resource.rb
const EnumPatternSchema = withDefaults({
  type: 'enum-pattern',
  fields: [
    { kind: 'attribute', name: 'pattern' },
    { kind: 'attribute', name: 'name' },
    { kind: 'attribute', name: 'flavor' },
    { kind: 'belongsTo', name: 'enum', type: 'enum', options: { async: false, inverse: null } },
  ],
});

export default EnumPatternSchema;
